import { faCheck, faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Pagination } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Tag } from "antd";
import CustomTable from "components/CustomTable";
import { selectCurrentUser } from "features/auth/authSlice";
import { useGetFPOByIdQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useApproveRejectFarmerMutation,
  useGetFarmerByIdQuery,
  useGetRequestedFarmersQuery,
} from "./farmerApiSlice";
import { CardHeader } from "reactstrap";
import useDebouncedValue from "hooks/useDebouncedValue";
import CustomSearchBar from "components/CustomSearchBar";
const FarmerRequest = () => {
  const { id } = useParams();
  const orgId = id ? id : "";
  const [farmers, setFarmers] = useState([]);
  const currentUser = useSelector(selectCurrentUser);

  const RoleAcessParams = currentUser?.realm_access?.roles;

  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [searchKey, setSearchKey] = useState("");
  const [remarks, setRemarks] = useState("");
  const [
    assignFarmer,
    createCrmleadresponse,
  ] = useApproveRejectFarmerMutation();
  const [showError, setError] = useState(false);
  const [currentId, setId] = useState("");
  const debouncedSearch = useDebouncedValue(searchKey);

  const handleChangeSearch = (message) => {
    setSearchKey(message);
  };
  const { data: data, refetch, isLoading } = useGetRequestedFarmersQuery({
    orgId,
    pagination,
    searchKey: debouncedSearch || "",
  });
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showFpo, setShowFpo] = useState(false);

  const handleCloseFpo = () => setShowFpo(false);
  const handleShowFpo = () => setShowFpo(true);
  const [farmerId, setFarmerId] = useState("");
  const [fpoId, setFpoId] = useState("");

  const [farmerDetailsById, setFarmerDetailsById] = useState([]);

  const { data: farmerById } = useGetFarmerByIdQuery(farmerId);
  const { data: fpoData } = useGetFPOByIdQuery(fpoId);
  const [fpoDataa, setFpoData] = useState([]);

  useEffect(() => {
    if (farmerById) {
      setFarmerDetailsById(farmerById?.data);
    }
  }, [farmerById]);

  useEffect(() => {
    if (fpoData) {
      setFpoData(fpoData?.data);
    }
  });
  const handleButtonStatus = (status, list) => {
    // console.log("happy sole", status);
    let payload = {
      request_id: list.id,
      status: status,
      remarks: remarks ? remarks : list.remarks,
    };
    assignFarmer({ payload })
      .unwrap()
      .then((data) => {
        if (data.success) {
          toast.success(`Farmer ${status.toLowerCase()} Successfully`);
          refetch();
          setRemarks("");
          setId("");
        }
      })
      .catch((error) => {
        toast.error(`Oops!! Something went wrong.`);
        return;
      });
  };
  const handleRemarks = (e, index) => {
    setRemarks(e.target.value);
    setError(false);
    setId(index);
  };
  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.stopPropagation();
    }
  };
  const handleDetailView = (id) => {
    setShow(true);
    setFarmerId(id);
  };

  const handleDetailViewFpo = (id) => {
    setShowFpo(true);
    setFpoId(id);
  };
  const columns = [
    {
      field: "customer_name",
      headerName: "Farmer Name",
      width: 180,
      renderCell: (cellvalues) => {
        return (
          <div className="mx-2 me-2">
            <FontAwesomeIcon
              icon={faEye}
              size="small"
              className="cursor-pointer f300 text-warning"
              onClick={() => handleDetailView(cellvalues.row.customer_id)}
            />
            <span className="mx-2"> {cellvalues.row.customer_name}</span>
          </div>
        );
      },
    },

    {
      field: "request_type",
      headerName: "Request Type",
      width: 150,
      renderCell: (params) => (
        <div
          className={
            params.row.request_type === "JOIN"
              ? "text-success f300 cursor-pointer mx-2"
              : "rejectButtonColor f300 cursor-pointer mx-2"
          }
        >
          {params.row.request_type}
        </div>
      ),
    },

    {
      field: "created_at",
      headerName: "Created At",
      width: 200,
      renderCell: (cellvalues) => {
        return (
          <div className="mx-2">
            {cellvalues.row.created_at
              ? cellvalues.row.created_at.slice(0, 10)
              : ""}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 170,
      renderCell: (params) => (
        <div
          className={
            params.row.status.toLowerCase() === "approved"
              ? "badge badge-success mx-2"
              : params.row.status.toLowerCase() === "rejected"
              ? "badge badge-danger mx-2"
              : "badge badge-warning mx-2"
          }
        >
          {params.row.status}
        </div>
      ),
    },

    {
      field: "",
      headerName: "Take Action",
      cellClassName: "remarksCell",
      width: 250,
      renderCell: (cellvalues) => {
        return cellvalues.row.status === "PENDING" ? (
          <>
            <button
              className={
                cellvalues.row.status === "APPROVED" ||
                cellvalues.row.status === "REJECTED"
                  ? "buttonTable remarksColor mx-2 mt-2 no-pointer "
                  : "buttonTable remarksColor mx-2 mt-2 cursor-pointer"
              }
              onClick={() => handleButtonStatus("REJECTED", cellvalues.row)}
              disabled={
                cellvalues.row.status === "APPROVED" ||
                cellvalues.row.status === "REJECTED"
              }
            >
              Reject
            </button>
            <button
              className={
                cellvalues.row.status === "APPROVED" ||
                cellvalues.row.status === "REJECTED"
                  ? "buttonTable mx-2 text-blue mt-2 no-pointer "
                  : "buttonTable mx-2 text-blue mt-2 cursor-pointer"
              }
              onClick={() => handleButtonStatus("APPROVED", cellvalues.row)}
              disabled={
                cellvalues.row.status === "APPROVED" ||
                cellvalues.row.status === "REJECTED"
              }
            >
              Approve
            </button>
          </>
        ) : (
          ""
        );
      },
    },
  ];
  if (RoleAcessParams.includes("admin")) {
    columns.splice(1, 0, {
      field: "organization_name",
      headerName: "FPO  Name",
      width: 210,
      renderCell: (cellvalues) => {
        return (
          <Tooltip title={cellvalues.row.organization_name}>
            <div className=" ">
              {cellvalues.row.organization_name?.substring(0, 20)}
              {cellvalues.row.organization_name?.length > 20 ? "..." : ""}
              &nbsp;{" "}
              <FontAwesomeIcon
                icon={faEye}
                size=""
                className="cursor-pointer f300 text-warning"
                style={{ fontSize: "10px" }}
                onClick={() =>
                  handleDetailViewFpo(cellvalues.row.organization_id)
                }
              />
            </div>
          </Tooltip>
        );
      },
    });
  }
  const tableData = {
    rows: farmers,
    columns: columns,
    paginationState: [pagination, setPagination],
    isLoading: isLoading,
    checkboxShowFalse: true,
  };

  useEffect(() => {
    const ApiData = data?.data?.results ? data.data.results : [];
    const paginationFromApi = data?.data?.pages
      ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
      : pagination;
    setFarmers(ApiData);
    setPagination(paginationFromApi);
  }, [data]);

  const handlePageChange = (event, value) => {
    setPagination((prev) => ({ ...prev, page: value }));
  };
  return (
    <div className="">
    
      <CardHeader className="mt-1 ">
      <Row className="">
        <Col md="2">
          <CustomSearchBar  />
        </Col>
        <Col lg="2" className="offset-md-8 mt-2">
        Total Farmer Requests :          <span className="text-success">&nbsp;{farmers?.length}</span>

        </Col>
      </Row>
      </CardHeader>
      <div className="py-3 d-lg-none d-md-none d-block">
        <div className="d-flex flex-lg-row flex-md-row flex-wrap ">
          {isLoading ? (
            <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
              <h5>Loading...</h5>
            </div>
          ) : farmers.length > 0 ? (
            farmers.map((farmer) => (
              <div
                className="card mb-3 col-lg-3 col-md-6 col-12 shadow-sm rounded-3 custom-hover-effect"
                key={farmer.id}
              >
                <div className="card-body p-3 fpo_card position-relative">
                  <div
                    className="d-flex align-items-center py-2 gap-3"
                    style={{ borderBottom: "1px solid #ebeaeab5" }}
                  >
                    <div>
                      <h5 className="text-success m-0 text-capitalize">
                        {farmer?.customer_name || "N/A"}
                      </h5>
                      <div className="d-flex">
                        <h6 style={{ color: "#5c5c5cb3" }}>
                          Request Type: {farmer.request_type || "N/A"}
                        </h6>
                      </div>
                    </div>

                    <button
                      className="btn btn-outline-primary position-absolute"
                      style={{ right: "4%", top: "10%" }}
                      onClick={() => handleDetailView(farmer?.customer_id)}
                    >
                      View
                    </button>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-1">
                    <span className="card-text d-flex gap-1 mt-1">
                      <i className="mdi mdi-phone text-warning me-2 fs-6"></i>
                      <h6>Phone:</h6> {farmer?.customer_phone_number || "N/A"}
                    </span>
                    <span className="card-text d-flex gap-1 mt-1">
                      <i className="mdi mdi-calendar-clock text-info me-2 fs-6"></i>
                      <h6>Created At:</h6> {farmer.created_at.slice(0, 10)}
                    </span>
                  </div>

                  <span className="card-text d-flex gap-1 mt-1">
                    <i className="mdi mdi-map-marker text-danger me-2 fs-6"></i>
                    {farmer?.customer_address || "N/A"}
                  </span>

                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <span className="card-text d-flex gap-1">
                      <i className="mdi mdi-information text-success me-2 fs-6"></i>
                      <h6>Status:</h6>{" "}
                      <Tag
                        bordered={false}
                        style={{ fontWeight: "500" }}
                        color={
                          farmer.status === "APPROVED"
                            ? "green"
                            : farmer.status === "PENDING"
                            ? "orange"
                            : "red"
                        }
                      >
                        {farmer.status}
                      </Tag>
                    </span>
                  </div>

                  {farmer.status === "PENDING" && (
                    <div className="d-flex justify-content-between mt-2">
                      <Button
                        variant="danger"
                        size="sm"
                        disabled={farmer.status !== "PENDING"}
                        onClick={() => handleButtonStatus("REJECTED", farmer)}
                      >
                        <FontAwesomeIcon icon={faTimes} className="me-1" />
                        Reject
                      </Button>
                      <Button
                        variant="success"
                        size="sm"
                        disabled={farmer.status !== "PENDING"}
                        onClick={() => handleButtonStatus("APPROVED", farmer)}
                      >
                        <FontAwesomeIcon icon={faCheck} className="me-1" />
                        Approve
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
              <h5>No Data Available</h5>
            </div>
          )}
        </div>

        <Pagination
          count={pagination.pageCount}
          page={pagination.page}
          onChange={handlePageChange}
          variant="outlined"
          shape="rounded"
        />
      </div>

      <div className="d-lg-block d-md-block d-none ">
        <CustomTable
          rows={tableData.rows}
          columns={tableData.columns}
          paginationState={tableData.paginationState}
          loading={tableData.isLoading}
          checkboxShowFalse={tableData.checkboxShowFalse}
        />
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>&nbsp;Farmer Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="row mt-2">
            <div className=" col-lg-3 col-4  text-center">
              <h6 className=" text-black">Farmer Name </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {farmerDetailsById.full_name}
              </h6>
            </div>
            <div className=" col-lg-3 col-3 text-center">
              <h6 className=" text-black">Total ACS </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {farmerDetailsById.total_acs?.toFixed(3)}
              </h6>
            </div>
            <div className=" col-lg-6 col-5 text-center">
              <h6 className=" text-black">Total Landholding </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {farmerDetailsById.total_land_holding}{" "}
                {farmerDetailsById.unit_of_land_holding}
              </h6>
            </div>
            <hr />
            <div className=" col-lg-3 col-4  text-center">
              <h6 className=" text-black">State </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {farmerDetailsById.state_name}
              </h6>
            </div>{" "}
            <div className=" col-lg-3 col-4 text-center">
              <h6 className=" text-black">Ocuupation </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {farmerDetailsById.primary_occupation}
              </h6>
            </div>
            <div className=" col-lg-6 col-4  text-center">
              <h6 className=" text-black">Address </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {farmerDetailsById.address}
              </h6>
            </div>
            <hr />
            <div className=" col-lg-3 col-4  text-center">
              <h6 className=" text-black">Farmer Phone </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {farmerDetailsById.phone_number}
              </h6>
            </div>
            <div className=" col-lg-3 col-4  text-center">
              <h6 className=" text-black">Email </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {farmerDetailsById.email}
              </h6>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showFpo} onHide={handleCloseFpo}>
        <Modal.Header closeButton>
          <Modal.Title>&nbsp;FPO Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="row mt-2">
            <div className=" col-lg-6 col-6  text-center">
              <h6 className=" text-black">FPO Name </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {fpoDataa.organization_name}
              </h6>
            </div>
            <div className=" col-lg-6 col-6  text-center">
              <h6 className=" text-black">Phone Number </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {fpoDataa.phone_number}
              </h6>
            </div>
            <hr />
            <div className=" col-lg-6  col-6 text-center">
              <h6 className=" text-black">Income </h6>
              <h6 className="bg-c-blue-textColor fw-bold">{fpoDataa.income}</h6>
            </div>
            <div className=" col-lg-6 col-6 text-center">
              <h6 className=" text-black">Organization Sector </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {fpoDataa.organization_sector}
              </h6>
            </div>
            <hr />
            <div className=" col-lg-6 col-6  text-center">
              <h6 className=" text-black">State </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {fpoDataa.state_name}
              </h6>
            </div>{" "}
            <div className=" col-lg-6 col-6 text-center">
              <h6 className=" text-black">Email </h6>
              <h6 className="bg-c-blue-textColor fw-bold">{fpoDataa.email}</h6>
            </div>
            <hr />
            <div className=" col-lg-6 col-6  text-center">
              <h6 className=" text-black">Address </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {fpoDataa.address}
              </h6>
            </div>
            <div className=" col-lg-6 col-6 text-center">
              <h6 className=" text-black">Landholding </h6>
              <h6 className="bg-c-blue-textColor fw-bold">
                {fpoDataa.land_holding}
              </h6>
            </div>
            <hr />
            <div className=" col-lg-6 col-6 text-center">
              <h6 className=" text-black">Total Farmers </h6>
              <h6 className="bg-c-blue-textColor fw-bold"></h6>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseFpo}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default FarmerRequest;
